import { i18nDispatcherHxDashboard } from 'models/i18n';
import {
  ConsumptionDeviceType,
  DeviceRole,
  ProductionDeviceType
} from 'utils/constants';
import { HxPlanningDeviceColumn } from 'views/modules/Dispatcher/HxDashboard/HxPlanning/HxPlanningContent/HxPlanningContentDevice/hxPlanningContentDeviceUtils';
import { HxPlanningContentDeviceHeaderAction } from 'views/modules/Dispatcher/HxDashboard/HxPlanning/HxPlanningContent/HxPlanningContentDevice/HxPlanningContentDeviceHeader/hxPlanningContentDeviceHeaderUtils';

// ==============================|| I18N EN ||============================== //

const enHxDashboard: i18nDispatcherHxDashboard = {
  devicePanel: {
    title: 'Device panel',
    selectDevice: {
      title: 'Select device',
      [DeviceRole.CONSUMPTION]: 'Consumption devices',
      [DeviceRole.PRODUCTION]: 'Production devices',
      [ConsumptionDeviceType.CONS]: 'Consumption',
      [ProductionDeviceType.FVE]: 'FVE',
      [ProductionDeviceType.BESS]: 'BESS',
      [ProductionDeviceType.MVE]: 'MVE',
      [ProductionDeviceType.KGJ]: 'KGJ'
    },
    chart: {
      label: {
        x: 'Time',
        y: 'Energy [MWh]'
      },
      currentPlan: 'Current plan',
      nomination: 'Nomination'
    }
  },
  siPanel: {
    title: 'Panel SI',
    chart: {
      yaxisSystemImbalanceLabel: 'SI [MWh]',
      yaxisSubjectImbalanceLabel: 'Subj. Imbalance [MWh]',
      predictionSystemImbalanceHXChartPoints: 'SI prediction',
      energyImbalanceChartPoints: 'Subject Imbalance',
      actualSystemImbalanceChartPoints: 'SI real'
    },
    table: {
      headerLabel: 'Period',
      groupedColumnsLabel: 'SI price',
      positiveSystemImbalanceProbability: 'Prob. SI > 0'
    }
  },
  hxPlanning: {
    header: {
      filterCaptionLabel: 'Filter',
      columns: {
        [HxPlanningDeviceColumn.NOMINATION]: 'Nomination',
        [HxPlanningDeviceColumn.CURRENT_PLAN]: 'Current plan',
        [HxPlanningDeviceColumn.PREDICTION]: 'Prediction',
        [HxPlanningDeviceColumn.SOC_MWH]: 'SoC/MWh'
      }
    },
    tables: {
      summary: {
        time: 'Time',
        estimatedSI: {
          title: 'Estimated SI',
          direction: 'Direct.',
          expectationSI: 'Precis. SI > 0',
          isp: 'ISP'
        },
        imbalance: {
          title: 'Imbalance',
          plan: 'Plan',
          currentPlan: 'Curr. plan',
          paymentForImbalance: 'Payment'
        },
        deliveryPrice: {
          title: 'Delivery price',
          nomination: 'Nomin.',
          currentPlan: 'Curr. plan'
        }
      },
      device: {
        actions: {
          [HxPlanningContentDeviceHeaderAction.DIRECT_CONFIRMATION]:
            'Direct confirmation',
          [HxPlanningContentDeviceHeaderAction.PROPAGATION]: 'Propagation',
          [HxPlanningContentDeviceHeaderAction.DIRECT_PROPAGATION]:
            'Direct propagation',
          [HxPlanningContentDeviceHeaderAction.SET_PREDICTION_TO_PRODUCTION]:
            'Set prediction to production'
        },
        header: {
          [HxPlanningDeviceColumn.NOMINATION]: 'Nomination',
          [HxPlanningDeviceColumn.CURRENT_PLAN]: 'Current plan',
          [HxPlanningDeviceColumn.PREDICTION]: 'Prediction',
          [HxPlanningDeviceColumn.SOC_MWH]: {
            soc: 'SoC',
            mwh: 'MWh'
          }
        }
      }
    }
  }
};

export default enHxDashboard;
